import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { Features } from './services/auth/features';
import { Functionalities } from './services/auth/functionalities';
import { Settings } from './settings.class';
import { LocalStorage } from './storage.class';
import { Utils } from './utils.class';

@Component({
    template: '',
    standalone: false,
})
export class CodaltComponent implements OnDestroy {
    readonly Functionalities = Functionalities;
    readonly Features = Features;
    readonly Roles = environment.roles;
    Utils = Utils;
    Settings = Settings;
    LocalStorage = LocalStorage;
    environment = environment;
    entitytypes = environment.entitytypes;

    protected subscriptions = new Subscription();

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
